import localforage from 'localforage'

let localforageStoreSSI = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'standard-survey-items'
})

const initialState = {
  all: [],
  standardSurveyItem: {
    id: null,
    name: {
      de: '',
      en: '',
      fr: ''
    }
  }
}

let state = initialState

const getters = {
  getAllStandardSurveyItems: state => state.all
}

const actions = {
  importStandardSurveyItems ({ commit }, standardSurveyItems) {
    return new Promise((resolve, reject) => {
      commit('clearStandardSurveyItemState')
      standardSurveyItems.forEach((standardSurveyItem) => {
        localforageStoreSSI.setItem(String(standardSurveyItem.id), JSON.stringify(standardSurveyItem))
      })
      commit('setStandardItemNamesToState', standardSurveyItems)
      resolve()
    })
  },
  loadAllStandardSurveyItems ({ commit }) {
    return new Promise((resolve, reject) => {
      let standardSurveyItems = []
      localforageStoreSSI.iterate((value) => {
        standardSurveyItems.push(JSON.parse(value))
      }).then(function () {
        commit('setStandardItemNamesToState', standardSurveyItems)
        resolve()
      })
    })
  },
  clearStandardSurveyItemsStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreSSI.clear().then(() => {
        commit('clearStandardSurveyItemState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setStandardItemNamesToState (state, standardSurveyItems) {
    state.all = standardSurveyItems
  },
  clearStandardSurveyItemState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/standard-survey-items.js